import { Loading } from '@app/components'
import { withShadowAuth } from '@app/hocs'

export default withShadowAuth(Loading)
